import { createElement, lazy } from 'react'

import { routes } from '../routes'
import { registerRoute } from '../utils/routeRegistry'

const PhysicalProcessWorkshop = lazy(() => import('./components/physicalProcessWorkshop'))

const initRoute = () => {
    registerRoute({ path: routes.PHYSICAL_PROCESS_WORKSHOP, element: createElement(PhysicalProcessWorkshop) })
}

export default initRoute
